var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltericongrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filter_icon_grey",
    "data-name": "Filter icon grey",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.457,
    height: 15.511,
    viewBox: "0 0 13.457 15.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31789",
    "data-name": "Rectangle 31789",
    width: 13.457,
    height: 15.511,
    fill: "#3c3c3b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12838",
    "data-name": "Group 12838",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38863",
    "data-name": "Path 38863",
    d: "M13.2,2.218H.256A.256.256,0,0,1,0,1.962V.255A.256.256,0,0,1,.256,0H13.2a.256.256,0,0,1,.256.256V1.962a.256.256,0,0,1-.256.256",
    transform: "translate(0 0.001)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38864",
    "data-name": "Path 38864",
    d: "M14.555,35.1H1.609c-.141,0-.18.086-.087.192L6.7,41.2v6.424a.151.151,0,0,0,.232.148l2.29-1.063a.437.437,0,0,0,.232-.363V41.2l5.183-5.91c.093-.106.054-.192-.087-.192",
    transform: "translate(-1.353 -32.281)",
    fill: "#3c3c3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericongrey);
export default __webpack_public_path__ + "static/media/Filter icon grey.bc8d490b474b8dfd6ab2c9bb90b3deb3.svg";
export { ForwardRef as ReactComponent };